"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _locale = require("date-fns/locale");
var _dateFns = require("date-fns");
Object.keys(_dateFns).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _dateFns[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _dateFns[key];
    }
  });
});
(0, _dateFns.setDefaultOptions)({
  locale: _locale.de,
  weekStartsOn: 1
});